export default "__VITE_ASSET__8u4_F7Om__"